import React, { useState, useEffect } from 'react';
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/eid-adha.webp";
import BlinkingText from '../../BlinkingText';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import MainCalculatorsList from '../MainCalculators';
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import moment from 'moment-hijri';
const TITLE = "Countdown to Eid al-Fitr 2026 - Remaining Time Until Eid al-Fitr 2026";
const DESCRIPTION = "Countdown to Eid al-Fitr 2026: How many days until Eid? When is Eid? Countdown to Eid 2026, Eid al-Fitr 2026 date, Eid al-Fitr 2026 countdown, Eid al-Fitr 2026 timing, remaining days until Eid al-Fitr, Eid al-Fitr 2026 countdown timer.";
const KEYWORDS = "Eid al-Fitr 2026 countdown, countdown to Eid, Eid al-Fitr date, Eid al-Fitr timing, Eid 2026, Eid al-Fitr countdown, countdown to Eid al-Fitr, days until Eid al-Fitr, Eid al-Fitr countdown timer, Eid al-Fitr 2026 timing, Eid celebration, Eid al-Fitr 2026 date, Eid al-Fitr countdown, Eid al-Fitr remaining days, Eid al-Fitr countdown 2026, countdown to Eid al-Fitr 2026, Eid al-Fitr timing, Eid al-Fitr 2026, Eid al-Fitr celebration, Eid al-Fitr countdown 2026, Eid al-Fitr date, Eid al-Fitr celebration 2026.";
const OG_URL = "https://do-calculate.com/articles-en/eid-fatr";
function Ramadan() {
    const [eidDates, setEidDates] = useState([
        { name: 'Eid al-Fitr 2026', date: new Date("2026-03-20T00:00:00") },
        { name: 'Eid al-Fitr 2027', date: new Date("2027-03-10T00:00:00") },
        { name: 'Eid al-Fitr 2028', date: new Date("2028-02-27T00:00:00") },
        { name: 'Eid al-Fitr 2029', date: new Date("2029-02-15T00:00:00") }
    ]);
    const nextEid = eidDates.find(d => d.name === 'Eid al-Fitr 2026')?.date || new Date("2026-03-20T00:00:00");
    const dayName = nextEid.toLocaleDateString('en-US', { weekday: 'long' });
    useEffect(() => {
        async function fetchEidDates() {
            try {
                const datesCol = collection(db, "dates");
                const querySnapshot = await getDocs(datesCol);
                let fetchedEid2026Date = null;
                const newEidDates = [];
                querySnapshot.forEach((doc) => {
                    const data = doc.data();
                    if (data.eid_fitr) {
                        const date = data.eid_fitr.toDate ? data.eid_fitr.toDate() : new Date(data.eid_fitr);
                        if (date.getFullYear() === 2026) {
                            fetchedEid2026Date = date;
                            newEidDates.push({ name: 'Eid al-Fitr 2026', date: date });
                        }
                    }
                });
                if (fetchedEid2026Date) {
                    setEidDates(prevDates =>
                        prevDates.map(item =>
                            item.name === 'Eid al-Fitr 2026'
                                ? { ...item, date: fetchedEid2026Date }
                                : item
                        )
                    );
                } else {
                    console.warn("No Eid al-Fitr 2026 date found in DB. Using default.");
                }
            } catch (error) {
                console.error("Error fetching Eid dates:", error);
            }
        }
        fetchEidDates();
    }, []);
    const calculateTimeLeft = (targetDate) => {
        const now = new Date();
        const difference = targetDate - now;
        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        }
        return timeLeft;
    };
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(nextEid));
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft(nextEid));
        }, 1000);
        return () => clearTimeout(timer);
    }, [timeLeft, nextEid]);
    return (
        <div>
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <FirstAds />
            </div>
            <h1 className='p-3 mb-2 bg-success text-white'>
                Countdown to Eid al-Fitr 2026
            </h1>
            <div>
                <BlinkingText
                    text={`Countdown to Eid al-Fitr: Eid al-Fitr 2026 is expected to begin on ${dayName}, ${nextEid?.toLocaleDateString('en-US')} (Gregorian) and ${moment(nextEid).format('iDD/iMM/iYYYY')} (Hijri).`}
                />
            </div>
            <div className="row">
                <div id="timer" style={{ width: '100%', fontSize: '40px' }}>
                    <table style={{ width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '1px solid #ccc', fontSize: '24px' }}>
                        <thead>
                            <tr>
                                <th >Days</th>
                                <th >Hours</th>
                                <th >Minutes</th>
                                <th >Seconds</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td id="days">{timeLeft.days}</td>
                                <td id="hours">{timeLeft.hours}</td>
                                <td id="minutes">{timeLeft.minutes}</td>
                                <td id="seconds">{timeLeft.seconds}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <SecondAds />
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <div>
                        <h2 className='p-3 mb-2 bg-success text-white' style={{ color: '#333', fontSize: '36px', textAlign: 'center' }}>Upcoming Eid al-Fitr Dates</h2>
                        <table style={{ fontSize: '24px', width: '100%', textAlign: 'center', borderCollapse: 'collapse', border: '2px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#f2f2f2' }}>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Eid al-Fitr Date</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Date</th>
                                    <th style={{ padding: '16px', borderBottom: '2px solid #ccc' }}>Remaining</th>
                                </tr>
                            </thead>
                            <tbody>
                                {eidDates.map((eid, index) => (
                                    <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                                        <td style={{ padding: '12px' }}>{eid.name}</td>
                                        <td style={{ padding: '12px' }}>{eid.date.toLocaleDateString('en-US')}</td>
                                        <td style={{ padding: '12px' }}>{calculateTimeLeft(eid.date).days} days</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col">
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.TimeArticles_En}></MainCalculatorsList>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <h3 className='p-3 mb-2 bg-success text-white'>Countdown to Eid al-Fitr 2026</h3>
                    <p>
                        In this article, we provide you with a detailed countdown to the blessed Eid al-Fitr, so you can always stay informed about how many days remain until this joyous occasion. Many of us wonder "how many days until Eid al-Fitr?" - this countdown timer helps you track exactly that.
                    </p>
                    <p>
                        According to our <a href='/calculator/en/gregorian_to_hijri/'>date converter</a>, Eid al-Fitr 2026 is expected to fall on {dayName}, {nextEid?.toLocaleDateString('en-US')} (Gregorian) and {moment(nextEid).format('iDD/iMM/iYYYY')} (Hijri). You can view the live countdown above.
                    </p>
                    <p>
                        The countdown shows exactly how many days, hours, minutes and seconds remain until Eid al-Fitr 2026.
                    </p>
                    <hr />
                    <RelatedLinks />
                    <hr />
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Eid al-Fitr Countdown Calculator
                    </h3>
                    <p>
                        This countdown shows the remaining time until Eid al-Fitr in both Gregorian and Hijri calendars. Track exactly how many days remain until the blessed Eid celebration. The countdown updates in real-time, showing days, hours, minutes and seconds until Eid al-Fitr 2026. May Allah accept our fasting and good deeds, and may He bring this Eid upon us with blessings and joy.
                    </p>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        About Eid al-Fitr
                    </h3>
                    <p>
                        Eid al-Fitr is one of the two major Islamic festivals, marking the end of Ramadan, the month of fasting. It is a day of celebration, gratitude to Allah, and strengthening community bonds. The Prophet Muhammad (peace be upon him) said: "When the month of Ramadan starts, the gates of heaven are opened and the gates of Hell are closed and the devils are chained." (Bukhari)
                    </p>
                    <div>
                        <br />
                        <img src={imageUrl} alt="Countdown to Eid al-Fitr"
                            width="800"
                            height="450"
                            style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
                            loading="lazy"
                        />
                        <br />
                    </div>
                    <h3 className='p-3 mb-2 bg-success text-white'>
                        Eid Etiquette and Traditions
                    </h3>
                    <p>
                        - Performing Ghusl (ritual bath) before Eid prayer<br />
                        - Wearing one's best clothes<br />
                        - Eating dates (odd number) before going to Eid prayer<br />
                        - Reciting Takbeer ("Allahu Akbar") on the way to prayer<br />
                        - Offering the Eid prayer in congregation<br />
                        - Giving Zakat al-Fitr before the prayer<br />
                        - Exchanging greetings and visiting family and friends<br />
                        - Showing happiness and sharing meals<br/>                        The Prophet (peace be upon him) said: "The people will continue to do well so long as they hasten to break the fast (during Ramadan) and delay the suhoor (pre-dawn meal)." (Ahmad)
                    </p>
                    <p>
                        Source: <a href='https://www.islamweb.net/ar/article/189088/'>IslamWeb</a>
                    </p>
                </div>
                <br />
            </div>
        </div>
    );
}
export default Ramadan;